import { ReactElement, useEffect } from "react";
import { changeLanguage } from "i18next";
import { configState } from "base/store/config";
import { useRecoilState } from "recoil";
import { useGetConfig } from "base/hooks/useConfig";
import Loader from "base/components/Loader";

interface Props {
  children: ReactElement;
}

const PageContainer = ({ children }: Props) => {
  const { data: configData } = useGetConfig();
  const [configStateValue, setConfigStateValue] = useRecoilState(configState);

  useEffect(() => {
    if (configData) {
      setConfigStateValue({
        ...configStateValue,
        ...configData,
        isLoadingConfig: false,
      });
    }
  }, [configData]);

  useEffect(() => {
    if (configStateValue?.lang) {
      changeLanguage(configStateValue.lang);
    }
  }, [configStateValue]);

  return (
    <>
      {configStateValue?.isLoadingConfig ? (
        <Loader type="page" loadingResource="Loading config" isFullPage />
      ) : (
        children
      )}
    </>
  );
};

export default PageContainer;
